<div class="card card-{{status}}">
  <div class="card-header">
    <div *ngIf="status!='info'" class="card-title-icon"></div>
    <h2 class="text-uppercase card-title">{{titulo}}</h2>


    <div *ngIf="erroUf" class="card-msg d-flex flex-column flex-md-row">
      <div>
        Informamos que a consulta CRLV-E está disponível apenas para os estados de AP, GO, MA, MT, PA, TO, RN, SP, MG E PR. 
        <br>
        Infelizmente, não há disponibilidade para a sua UF no momento.
      </div>
    </div>


    <div *ngIf="msg && !erroUf" class="card-msg d-flex flex-column flex-md-row">
      <div>
        {{msg}}
      </div>
      <div *ngIf="codigoControle=='ERRO_FORNECEDOR' && tipoConsulta != 'GRAVAME_SIMPLES' && !reloadStatus " class="pl-xl-5 pl-md-3 pl-2">
        <button [disabled]="atualizando" class="mt-2 mt-md-0 btn-recarregar-consulta btn btn-primary btn-icon" (click)="atualizarConsulta()">
          <i *ngIf="atualizando" class="mdi mdi-spin mdi-loading"></i>
          <span>{{atualizando ? 'AGUARDE, RECONSULTANDO' : 'REFAZER CONSULTA'}}</span>
        </button>
      </div>
      <div *ngIf="reloadStatus" class="pl-xl-5 pl-md-3 pl-2">
        <app-knob-cron [timeCron]="timeCron" [size]="70"></app-knob-cron>
      </div>
    </div>
  </div>
  <ng-content *ngIf="codigoControle!='ERRO_FORNECEDOR' && codigoControle!='PENDENTE'  && codigoControle!='SEMREGISTRO_OK' && codigoControle!='CORTESIA' && codigoControle!='SEMREGISTRO_NAOCOBRAR'"></ng-content>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <dados-bloco-detran *ngIf="binestErro"></dados-bloco-detran>
      </div>
    </div>
  </div>

</div>
